import Immutable from 'immutable';
import { READ_BROWSER_CONTEXT, READ_REQUEST_CONTEXT } from './actions';
import { OL_ORIGIN } from './constants';

const initialUrlState = Immutable.fromJS({
  origin: null,
  customDomain: null,
  protocol: null,
  userAgent: null,
  inAppWebview: null,
});

export const url = (state = initialUrlState, action) => {
  switch (action.type) {
    case READ_BROWSER_CONTEXT:
    case READ_REQUEST_CONTEXT: {
      return Immutable.fromJS({
        origin: action.origin,
        customDomain: action.origin === OL_ORIGIN ? null : action.hostname,
        protocol: action.protocol,
        userAgent: action.userAgent,
        inAppWebview: action.userAgent
          ? action.userAgent.includes('OpenLearning-iOS') ||
            action.userAgent.includes('OpenLearning-Android')
          : null,
      });
    }
    default: {
      return state;
    }
  }
};
